export default __webpack_public_path__ + "static/causa-global-medio-ambiente-874cc08a613434601a8e1433aab35e1f.png";